<template>
    <div class="col-12 col-lg-8 offset-lg-2">
        <a href="/user/login" class="justify-content-between align-items-center d-flex bg-white shadow rounded mb-2 cursor-pointer text-decoration-none">
            <div class="d-flex align-items-center">
                <div>
                    <i class="fa-solid fa-user mx-3" :class="iconColour"></i>
                </div>
                <div class="py-2">
                    <p class="mb-0">My Account</p>
                    <p class="mb-0">You can manage your order from here</p>
                </div>
            </div>
            <div class="">
                <i class="fa-solid fa-chevron-right mx-3"></i>
            </div>
        </a>
        <div v-if="livechat" class="justify-content-between align-items-center d-flex bg-white shadow rounded mb-2 cursor-pointer text-decoration-none" @click="startLiveChat()">
            <div class="d-flex align-items-center">
                <div>
                    <i class="fa-solid fa-comment mx-3" :class="iconColour"></i>
                </div>
                <div class="py-2">
                    <p class="mb-0">Chat With Us</p>
                    <p class="mb-0">Talk to our friendly tyre advisors online</p>
                </div>
            </div>
            <div class="">
                <i class="fa-solid fa-chevron-right mx-3"></i>
            </div>
        </div>
        <div class="justify-content-between align-items-center d-flex bg-white shadow rounded mb-2 cursor-pointer text-decoration-none" @click="showContactForm()">
            <div class="d-flex align-items-center">
                <div>
                    <i class="fa-solid fa-at mx-3" :class="iconColour"></i>
                </div>
                <div class="py-2">
                    <p class="mb-0">Raise A Ticket / Email Us</p>
                    <p class="mb-0">Send us an email and we'll get back as soon as possible</p>
                </div>
            </div>
            <div class="">
                <i class="fa-solid fa-chevron-right mx-3"></i>
            </div>
        </div>
        <div class="row" :class="{'g-sm-3': faqsExist}">
            <div class="col-12">
                <div v-if="faqsExist" class="justify-content-between align-items-center d-flex bg-white shadow rounded mb-2 cursor-pointer" @click="showInteractive()">
                    <div class="d-flex align-items-center">
                        <div>
                            <i class="fa-solid fa-phone mx-3" :class="iconColour"></i>
                        </div>
                        <div class="py-2">
                            <p class="mb-0">Phone Us</p>
                        </div>
                    </div>
                    <div class="">
                        <i class="fa-solid fa-chevron-right mx-3"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['customerServiceEmail', 'faqs', 'iconColour', 'livechat'],
        methods: {
            showInteractive() {
                this.emitter.emit('showInteractive', true);
            },
            showContactForm() {
                this.emitter.emit('showContactForm', true);
            },
            showAddress() {
                this.emitter.emit('showAddress', true);
            },
            startLiveChat() {
                var liveChatTyre = document.getElementById('liveChatTyre');
                var liveChatBackground = document.getElementById('liveChatBackground');
                
                liveChatTyre.classList.toggle('d-none');
                liveChatBackground.classList.toggle('d-none');
                
                setTimeout(() => {
                    liveChatTyre.classList.toggle('d-none');
                    liveChatBackground.classList.toggle('d-none');
                }, 3000);
            }
        },
        computed: {
            faqsExist() {
                return (this.faqs.mobile.length > 0 || this.faqs.garage.length > 0 || this.faqs.home_delivery.length > 0)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>